import cx from "classnames";
import { twMerge } from "tailwind-merge";

export const clsx = (...args: cx.ArgumentArray) => twMerge(cx(...args));
